import { ProviderModule } from './helpers/account-helper'
const ProviderInsider = 'insider'

const module = ProviderModule(ProviderInsider)

module.actions.create = async ({ commit }, { companyId, api_keys, partner_name }) => {
	try {
		let body = {
			api_keys,
			extra_data: { partner_name },
			company_id: companyId,
			provider: 'insider',
		}

		const res = await useNuxtApp().$fetchCrmBridge('/integrations/', {
			method: 'POST',
			body,
		})

		if (res) {
			commit('assign', { companyId, data: res })
			return res
		}
	} catch (err) {
		commit('clear')
		throw err
	}
}

export default module
